import { createSelector } from 'reselect';
import { currentClientIdSelector } from '../CommonSelectors/CommonAreaSelector';

export const defined = obj => obj || {};

export const financialPlan = state => state.NewFinancialPlan;
export const selectIsLoading = createSelector(financialPlan, ({ isLoading }) => isLoading);
export const currentClientId = state => financialPlan(state).currentClientId;
export const data = createSelector(
  currentClientIdSelector,
  financialPlan,
  (clientId, fp) => defined(fp[clientId]).data,
);
export const errors = (state, props) => defined(financialPlan(state)[props.clientId]).errors || [];
export const errorType = (state, props) =>
  defined(financialPlan(state)[props.clientId]).errorType || null;
export const calibration = (state, props) =>
  defined(financialPlan(state)[props.clientId]).calibration;
export const isCalibrating = (state, props) => defined(data(state, props)).IsCalibrating || false;
export const goals = (state, props) => defined(data(state, props)).Goals || [];
export const doNotUpdateCalibration = (state, props) =>
  defined(financialPlan(state)[props.clientId]).doNotUpdateCalibration;

export const selectDisplayAssetBucketing = (state, props) =>
  defined(data(state, props)).DisplayAssetBucketing || false;

export const isResettingFinancialPlanSelector = state =>
  financialPlan(state).isResettingFinancialPlan;

export const currentClientDataSelector = createSelector(
  financialPlan,
  currentClientId,
  (financialPlanState, id) => financialPlanState[id].data,
);

export const showTaxBracketOptionSelector = createSelector(
  currentClientDataSelector,
  planData => planData.GeneralAssumptions.EffectiveTaxRate === null,
);
